import {Injectable} from '@angular/core';
import {StorageService} from '@twict4fiber/storage';
import {SK_1_SETTINGS_PREFERENCES_HIDE_FUTURE_TASKS, SK_1_SETTINGS_PREFERENCES_MAP_SERVICE, SK_1_SETTINGS_PREFERENCES_SWAP_DEFAULT_PHOTOS_POSITION} from '../constants/storage-keys';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  private _hideFutureTasks: boolean;
  private _navigationService: string;
  private _swapDefaultPhotosPosition: boolean;

  public get hideFutureTasks(): boolean {
    return this._hideFutureTasks;
  }

  public get navigationService(): string {
    return this._navigationService;
  }

  public get swapDefaultPhotosPosition(): boolean {
    return this._swapDefaultPhotosPosition;
  }

  public constructor(private storageService: StorageService) {
  }

  public async initialize(): Promise<void> {
    const hideFutureTasks: any = await this.storageService.getItem(SK_1_SETTINGS_PREFERENCES_HIDE_FUTURE_TASKS);

    try {
      if (typeof hideFutureTasks === 'boolean') {
        this._hideFutureTasks = hideFutureTasks;
      }
    } catch (err: any) {
      console.warn(err);
    }

    const navigationService: any = await this.storageService.getItem(SK_1_SETTINGS_PREFERENCES_MAP_SERVICE);

    try {
      if (typeof navigationService === 'string') {
        this._navigationService = navigationService;
      }
    } catch (err: any) {
      console.warn(err);
    }

    const swapDefaultPhotosPosition: any = await this.storageService.getItem(SK_1_SETTINGS_PREFERENCES_SWAP_DEFAULT_PHOTOS_POSITION);

    try {
      if (typeof swapDefaultPhotosPosition === 'boolean') {
        this._swapDefaultPhotosPosition = swapDefaultPhotosPosition;
      }
    } catch (err: any) {
      console.warn(err);
    }
  }

  public async setPhotosAtBottom(photosAtBottom: boolean): Promise<void> {
    if (this._swapDefaultPhotosPosition !== photosAtBottom) {
      this._swapDefaultPhotosPosition = photosAtBottom;

      if (this._swapDefaultPhotosPosition) {
        await this.storageService.setItem(SK_1_SETTINGS_PREFERENCES_SWAP_DEFAULT_PHOTOS_POSITION, this._swapDefaultPhotosPosition);
      } else {
        await this.storageService.removeItem(SK_1_SETTINGS_PREFERENCES_SWAP_DEFAULT_PHOTOS_POSITION);
      }
    }
  }

  public async setHideFutureTasks(hideFutureTasks: boolean): Promise<void> {
    if (this._hideFutureTasks !== hideFutureTasks) {
      this._hideFutureTasks = hideFutureTasks;

      if (this._hideFutureTasks) {
        await this.storageService.setItem(SK_1_SETTINGS_PREFERENCES_HIDE_FUTURE_TASKS, this._hideFutureTasks);
      } else {
        await this.storageService.removeItem(SK_1_SETTINGS_PREFERENCES_HIDE_FUTURE_TASKS);
      }
    }
  }

  public async setNavigationService(navigationService: string): Promise<void> {
    if (this._navigationService !== navigationService) {
      this._navigationService = navigationService;

      if (this._navigationService) {
        await this.storageService.setItem(SK_1_SETTINGS_PREFERENCES_MAP_SERVICE, this._navigationService);
      } else {
        await this.storageService.removeItem(SK_1_SETTINGS_PREFERENCES_MAP_SERVICE);
      }
    }
  }

}
